import { useEffect, useMemo, useState } from "react";
import { io } from "socket.io-client";

export default function ChatSocket() {
  const socket = useMemo(() => io("http://localhost:4001"), []);

  const [roomId, setRoomId] = useState("room1");
  const [name, setName] = useState("Sunil");
  const [joined, setJoined] = useState(false);

  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    socket.on("receive_message", (data) => {
      setMessages((prev) => [...prev, data]);
    });

    return () => {
      socket.off("receive_message");
    };
  }, [socket]);

  const joinRoom = () => {
    if (!roomId.trim()) return;
    socket.emit("join_room", roomId);
    setJoined(true);
  };

  const sendMessage = () => {
    if (!message.trim()) return;

    const data = {
      roomId,
      sender: name,
      message,
      time: new Date().toLocaleTimeString(),
    };

    socket.emit("send_message", data);
    setMessage("");
  };

  return (
    <div style={{ fontFamily: "Arial", padding: 20 }}>
      <h2>Socket Chat App (Node + React)</h2>

      {!joined ? (
        <div style={{ marginTop: 20 }}>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your name"
            style={{ padding: 10, marginRight: 10 }}
          />
          <input
            value={roomId}
            onChange={(e) => setRoomId(e.target.value)}
            placeholder="Room ID"
            style={{ padding: 10, marginRight: 10 }}
          />
          <button onClick={joinRoom} style={{ padding: 10 }}>
            Join Room
          </button>
        </div>
      ) : (
        <>
          <div style={{ marginTop: 20 }}>
            <b>Room:</b> {roomId} | <b>User:</b> {name}
          </div>

          <div
            style={{
              marginTop: 20,
              border: "1px solid #ddd",
              height: 300,
              overflowY: "auto",
              padding: 10,
              borderRadius: 10,
            }}
          >
            {messages.map((m, i) => (
              <div
                key={i}
                style={{
                  textAlign: m.sender === name ? "right" : "left",
                  marginBottom: 10,
                }}
              >
                <div style={{ fontSize: 12, color: "#666" }}>
                  {m.sender} • {m.time}
                </div>
                <div
                  style={{
                    display: "inline-block",
                    padding: "10px 12px",
                    borderRadius: 12,
                    background: m.sender === name ? "#dff7df" : "#f1f1f1",
                    maxWidth: "70%",
                  }}
                >
                  {m.message}
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 10 }}>
            <input
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type message..."
              style={{ padding: 10, width: "70%", marginRight: 10 }}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button onClick={sendMessage} style={{ padding: 10 }}>
              Send
            </button>
          </div>
        </>
      )}
    </div>
  );
}
